import React, { useState } from "react";

import CharacterCreatorApp from "./CharacterCreatorApp.jsx";
import CharacterHub from "./components/CharacterHub.jsx";
import { createStateSnapshot } from "./characterCreatorUtils.js";

const LS_KEY = "worldhub_characters";

function saveCharacter(state, editIndex = null) {
  try {
    const snapshot = createStateSnapshot(state);
    const chars = JSON.parse(localStorage.getItem(LS_KEY) || "[]");
    if (editIndex !== null) {
      chars[editIndex] = snapshot;
    } else {
      chars.push(snapshot);
    }
    localStorage.setItem(LS_KEY, JSON.stringify(chars));
  } catch (e) {
    console.error("Erro ao salvar personagem:", e);
  }
}

export default function PersonagemApp() {
  const [view, setView] = useState("hub");
  const [editData, setEditData] = useState(null); // { index, snapshot }

  function handleComplete(state) {
    saveCharacter(state, editData?.index ?? null);
    setEditData(null);
    setView("hub");
  }

  function handleCancel() {
    setEditData(null);
    setView("hub");
  }

  function handleEdit(index, snapshot) {
    setEditData({ index, snapshot });
    setView("creator");
  }

  if (view === "creator") {
    return (
      <CharacterCreatorApp
        onComplete={handleComplete}
        onCancel={handleCancel}
        initialState={editData?.snapshot}
      />
    );
  }

  return (
    <CharacterHub
      onNewCharacter={() => setView("creator")}
      onEdit={handleEdit}
    />
  );
}
